// Modal for selecting hiplot features to display
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// Context
import ViewContext from "../../context/view/ViewContext";
import {
	absoluteFeatures,
	fileSpecificFeatures,
	readFeatures,
	writeFeatures,
	otherFeatures,
	logFeatures,
} from "../../context/FeaturesData";
// UI
import { useSpring, animated } from "react-spring/web.cjs";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid black",
		boxShadow: theme.shadows[5],
		padding: "40px",
	},
}));

const Fade = React.forwardRef(function Fade(props, ref) {
	const { in: open, children, onEnter, onExited, ...other } = props;
	const style = useSpring({
		from: { opacity: 0 },
		to: { opacity: open ? 1 : 0 },
		onStart: () => {
			if (open && onEnter) {
				onEnter();
			}
		},
		onRest: () => {
			if (!open && onExited) {
				onExited();
			}
		},
	});

	return (
		<animated.div ref={ref} style={style} {...other}>
			{children}
		</animated.div>
	);
});

Fade.propTypes = {
	children: PropTypes.element,
	in: PropTypes.bool.isRequired,
	onEnter: PropTypes.func,
	onExited: PropTypes.func,
};

const HiPlotSelectionModal = ({ index }) => {
	const classes = useStyles();
	const {
		hiPlotModal,
		setHiPlotModal,
		setHiPlotValues,
		hiPlotValues,
	} = React.useContext(ViewContext);

	return (
		<div>
			<Modal
				aria-labelledby="spring-modal-title"
				aria-describedby="spring-modal-description"
				className={classes.modal}
				open={hiPlotModal}
				onClose={() => setHiPlotModal(false)}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={hiPlotModal}>
					<div className={classes.paper}>
						<h2 style={{ textAlign: "center" }}>HiPlot Options</h2>
						<div style={{ display: "flex" }}>
							<div style={{ marginLeft: "85px" }}>
								<h4>Absolute Value Features</h4>
								{logFeatures.map((feature) => {
									return (
										<div style={{ width: "325px" }}>
											<Checkbox
												inputProps={{
													"aria-label":
														"primary checkbox",
												}}
												onChange={setHiPlotValues}
												name={feature}
												checked={hiPlotValues.includes(
													feature
												)}
											/>
											{feature}
										</div>
									);
								})}
							</div>

							<div>
								<h4>Relative Value Features</h4>
								{absoluteFeatures.map((feature) => {
									return (
										<div style={{ width: "300px" }}>
											<Checkbox
												inputProps={{
													"aria-label":
														"primary checkbox",
												}}
												onChange={setHiPlotValues}
												name={feature}
												checked={hiPlotValues.includes(
													feature
												)}
											/>
											{feature}
										</div>
									);
								})}

								<h4 style={{ marginTop: "30px" }}>
									File-Specific Features
								</h4>
								{fileSpecificFeatures.map((feature) => {
									return (
										<div style={{ width: "350px" }}>
											<Checkbox
												inputProps={{
													"aria-label":
														"primary checkbox",
												}}
												onChange={setHiPlotValues}
												name={feature}
												checked={hiPlotValues.includes(
													feature
												)}
											/>
											{feature.toUpperCase()}
										</div>
									);
								})}
							</div>
							<div>





								<h4>Read Access Size Features</h4>
								{readFeatures.map((feature) => {
									return (
										<div
											style={{ width: "375px" }}
											key={feature}
										>
											<Checkbox
												inputProps={{
													"aria-label":
														"primary checkbox",
												}}
												onChange={setHiPlotValues}
												name={feature}
												checked={hiPlotValues.includes(
													feature
												)}
											/>
											{feature}
										</div>
									);
								})}
							</div>
							<div>
								<h4>Write Access Size Features</h4>
								{writeFeatures.map((feature) => {
									return (
										<div style={{ width: "400px" }}>
											<Checkbox
												inputProps={{
													"aria-label":
														"primary checkbox",
												}}
												onChange={setHiPlotValues}
												name={feature}
												checked={hiPlotValues.includes(
													feature
												)}
											/>
											{feature}
										</div>
									);
								})}
							</div>


							<div>
								<h4>Other Features</h4>
								{otherFeatures.map((feature) => {
									return (
										<div
											style={{ width: "400px" }}
											key={feature}
										>
											<Checkbox
												inputProps={{
													"aria-label":
														"primary checkbox",
												}}
												onChange={setHiPlotValues}
												name={feature}
												checked={hiPlotValues.includes(
													feature
												)}
											/>
											{feature}
										</div>
									);
								})}
							</div>
						</div>
						<Link
							to={`/hiplot/${index}/${hiPlotValues}`}
							target="_blank"
							style={{
								margin: "0 100px 100px 1600px",
							}}
						>
							<Button
								onClick={() => setHiPlotModal(false)}
								color="primary"
								variant="contained"
							>
								Create HiPlot
							</Button>
						</Link>
					</div>
				</Fade>
			</Modal>
		</div>
	);
};

export default HiPlotSelectionModal;
